import React from "react";
import { ExternalLink, MapPin, ShoppingBag, Navigation } from "lucide-react";
import { Button } from "../components/ui/button";
import PageHero from "../components/PageHero";
import { images, salesPoints, club } from "../mock/mock";
import { mapsUrl } from "../lib/maps";

export default function Gastkarten() {
  return (
    <div>
      <PageHero
        eyebrow="Tageskarten"
        title="Gastkarten"
        subtitle="Angelt an unseren Gewässern – Tageskarten online oder an einer unserer Verkaufsstellen."
        image={images.anglerAutumn}
      />

      {/* Online CTA */}
      <section className="py-24 bg-background">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="bg-primary rounded-3xl p-10 lg:p-14 text-primary-foreground grid lg:grid-cols-2 gap-8 items-center overflow-hidden relative">
            <div
              className="absolute inset-0 opacity-10 bg-cover bg-center"
              style={{ backgroundImage: `url(${images.calmLake})` }}
            />
            <div className="relative">
              <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
                Neu ab 2026
              </span>
              <h2 className="font-serif text-4xl font-600 leading-tight">
                Angelkarten online kaufen
              </h2>
              <p className="mt-4 text-lg text-primary-foreground/80 font-300 leading-relaxed">
                Bequem von zu Hause: Bezieht eure Tageskarten jetzt online über
                unseren Partner „hejfish“ – schnell, einfach und jederzeit
                verfügbar.
              </p>
            </div>
            <div className="relative flex lg:justify-end">
              <a href={club.hejfish} target="_blank" rel="noopener noreferrer">
                <Button
                  size="lg"
                  className="bg-accent hover:bg-accent/90 text-accent-foreground font-600 text-base h-14 px-8 gap-2"
                >
                  <ShoppingBag className="h-5 w-5" />
                  Zu hejfish
                  <ExternalLink className="h-4 w-4" />
                </Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Verkaufsstellen */}
      <section className="pb-24 bg-background">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="max-w-2xl mb-12">
            <span className="inline-block text-accent text-sm font-600 uppercase tracking-[0.25em] mb-3">
              Vor Ort
            </span>
            <h2 className="font-serif text-3xl md:text-4xl font-600 text-foreground leading-tight">
              Unsere Verkaufsstellen
            </h2>
            <p className="mt-3 text-lg text-muted-foreground font-300">
              An diesen Stellen erhaltet ihr unsere Tageskarten persönlich.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {salesPoints.map((s) => (
              <div
                key={s.name}
                className="bg-card border border-border rounded-2xl p-6 hover:shadow-lg hover:border-primary/30 transition-all flex flex-col"
              >
                <div className="h-11 w-11 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
                  <MapPin className="h-6 w-6 text-primary" />
                </div>
                <h3 className="font-600 text-lg text-foreground">{s.name}</h3>
                <p className="text-muted-foreground mt-1 text-sm leading-relaxed flex-1">
                  {s.address}
                </p>
                <a
                  href={mapsUrl(s.address)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`route-link-${s.name.replace(/[^a-zA-Z0-9]/g, "-").toLowerCase()}`}
                  className="mt-4 inline-flex items-center justify-center gap-2 h-11 rounded-xl bg-secondary text-primary font-600 text-sm hover:bg-primary hover:text-primary-foreground transition-colors"
                >
                  <Navigation className="h-4 w-4" />
                  Route planen
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
